import React from 'react';
import { DocLink, DocPages } from 'components/Help';
import { TagValues } from './Values';
import TaggedItems from './TaggedItems';
import TagFormInput from './input';

const config = {
  init: {
    mutually_exclusive: false,
    used_by_optimiser: false
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Theme',
        dataIndex: 'theme__model',
        width: '200px',
        sorter: true,
        render: (text, record) => (record.theme.model)
      },
      {
        title: 'Mutually Exclusive',
        dataIndex: 'mutually_exclusive',
        width: '180px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Yes',
            value: true
          },
          {
            text: 'No',
            value: false
          }
        ],
        render: (text, record) => (record.mutually_exclusive ? 'Yes' : 'No')
      },
      {
        title: 'Used by Optimiser',
        dataIndex: 'used_by_optimiser',
        width: '180px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Yes',
            value: true
          },
          {
            text: 'No',
            value: false
          }
        ],
        render: (text, record) => (record.used_by_optimiser ? 'Yes' : 'No')
      },
      {
        title: 'Total Tags',
        dataIndex: 'tag_value_count',
        width: '140px',
        align: 'center',
        sorter: false
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the tag
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      },
      theme__model: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['theme__model'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.tags}>Tags</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Tag',
    title: 'Tag',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <TagFormInput
            {...props}
            title="Tag"
          />
        )
      },
      {
        key: 1,
        title: 'Manage Tags',
        component: props => (
          <TagValues
            {...props}
            title="Tag Values"
          />
        )
      },
      {
        key: 2,
        title: 'Tagged Items',
        visible: record => record && record.theme && record.theme.model === 'user',
        component: props => (
          <TaggedItems
            {...props}
            title="Tagged Items"
          />
        )
      }
    ]
  }
};

export default config;
